import { GenericPipelineSettingsFragment } from '@warebee/frontend/data-access-api-graphql';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import KeyValueItem from '../../../components/KeyValueItem';
import usePipelineTemplateDescriptors from '../../templateDescriptors/usePipelineTemplateDescriptors';

export type ProcessingPipelineGenericSectionProperties = {
  settings: GenericPipelineSettingsFragment;
};
const ProcessingPipelineGenericSectionProperties: React.FC<
  ProcessingPipelineGenericSectionProperties
> = props => {
  const { t } = useTranslation('dataset');
  const { settings } = props;
  const templateDescriptors = usePipelineTemplateDescriptors();

  if (_.isNil(props.settings?.templateId)) {
    return null;
  }

  const settingsDescriptor = templateDescriptors[props.settings.templateId];
  const mappedParamsMap = _.keyBy(props.settings.parameterMapping, 'name');

  if (_.isNil(settingsDescriptor)) {
    return null;
  }

  return (
    <>
      <KeyValueItem
        keyName={t`Template`}
        keyValue={settings.templateId}
        isDisabled={true}
        classNameKeyName="flex-1 text-sm text-menu-text/50"
        classNameKeyValue="bg-app-panel-dark/50 text-xs py-1 px-2 rounded flex-none"
        style={{
          noStyle: true,
          inline: true,
          textSize: 'xxs',
          customClassName: 'py-0.5',
        }}
      />
      {_.map(settingsDescriptor.templateParameters, paramDescriptor => {
        const Render = paramDescriptor.render;
        const value = _.has(mappedParamsMap, paramDescriptor.parameterId)
          ? mappedParamsMap[paramDescriptor.parameterId]
          : paramDescriptor.defaultValue;

        return <Render key={paramDescriptor.parameterId} value={value} />;
      })}
    </>
  );
};

export default ProcessingPipelineGenericSectionProperties;
